export enum SPECIAL_SUPPLIER_IDS {
    AVM = '101130'
}

export const isSpecialSupplierProduct = (
    specialId: SPECIAL_SUPPLIER_IDS,
    supplierId?: string,
    aggregatedMainChannelQuantity?: number
): boolean => {
    if (!supplierId) {
        return false;
    }

    if (aggregatedMainChannelQuantity === undefined || aggregatedMainChannelQuantity !== 0) {
        return false;
    }

    return supplierId === specialId;
};

export const isItShopProduct = (supplierId?: string, aggregatedMainChannelQuantity?: number): boolean =>
    isSpecialSupplierProduct(SPECIAL_SUPPLIER_IDS.AVM, supplierId, aggregatedMainChannelQuantity);
